
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"19","viewBox":"0 0 13 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.66198 0.584473C10.076 0.584473 12.8535 3.36202 12.8535 6.77601C12.8535 11.067 6.65589 18.397 6.65589 18.397C6.65589 18.397 0.470436 10.856 0.470436 6.77601C0.470436 3.36202 3.24788 0.584473 6.66198 0.584473ZM4.79386 8.5889C5.30897 9.1039 5.98542 9.36145 6.66198 9.36145C7.33842 9.36145 8.01509 9.1039 8.52998 8.5889C9.56009 7.5589 9.56009 5.88289 8.52998 4.85278C8.03118 4.35376 7.36767 4.07891 6.66198 4.07891C5.95628 4.07891 5.29288 4.35386 4.79386 4.85278C3.76375 5.88289 3.76375 7.5589 4.79386 8.5889Z","fill":"white"}})])
          )
        }
      }
    